/** The permissions the accounting routes check, one constant each, so a screen gates a button on exactly what its route needs. */
export const ACCOUNTING_READ = "accounting.read";
export const JOURNALS_WRITE = "accounting.journals.write";
export const JOURNALS_APPROVE = "accounting.journals.approve";
export const ACCOUNTING_REVERSE = "accounting.reverse";
export const CONTROL_OVERRIDE = "accounting.control_override";
export const ACCOUNTING_CLOSE = "accounting.close";
export const ACCOUNTING_REOPEN = "accounting.reopen";
export const ACCOUNTING_LOCK = "accounting.lock";
export const ACCOUNTING_SETTINGS = "accounting.settings";
export const BANK_DEPOSITS = "accounting.bank.deposits";
